var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPersonalize = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "19px",
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "personalize") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-Sixtbook_dashboard-without-menus",
    transform: "translate(-452.000000, -200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "center",
    transform: "translate(430.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "post",
    transform: "translate(0.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "personalize",
    transform: "translate(20.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7733952,3.51221407 C18.4568027,2.82926198 19.5645539,2.82926198 20.2480692,3.51221407 L21.0093251,4.27350446 C21.692625,4.95697661 21.692625,6.06473858 21.0093251,6.74822151 L10.2180323,17.539342 L7.42707644,18.2369625 C6.7370254,18.4094564 6.11217103,17.7843006 6.28462187,17.0945402 L6.98229625,14.3033044 L17.7733952,3.51221407 Z M11,6 L11,4 L2,4 L2,21.9987488 L21,21.9987488 L21,13 L19,13 L19,20 L4.00389099,20.0001221 L4,6 L11,6 Z M20.057486,5.79660853 L19.0106783,6.84338388 L17.6782113,5.5111214 L18.7252343,4.46382921 C18.8829768,4.30662501 19.1384875,4.30662501 19.2962301,4.46382921 L20.057486,5.22564504 C20.2152286,5.38283847 20.2152286,5.63888749 20.057486,5.79660853 Z M16.7265875,6.46273438 L18.0591623,7.79499687 L9.53035013,16.3237013 L7.75383505,16.7679647 L8.19809842,14.9914496 L16.7265875,6.46273438 Z",
    id: "Shape",
    fill: "#191919"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPersonalize);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/personalize.617d6a71e53836b3e8d82f3becad070d.svg";